/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/alt-text */
import { useRef } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import SavvyDisplaysLogo from '../../Assets/icons/SavvyDisplaysLogo.png';
import Person2Icon from '@mui/icons-material/Person2';
import React, { useEffect, useCallback } from 'react';
import OnboardingProgressBarDSO from '../OnBoardingBarDSO';
import OnboardingProgressBarADV from '../OnBoardingBarADV';
import NotificationsIcon from '@material-ui/icons/Notifications';
import AppNotifications from '../AppNotifications';
import NewInventoryWidget from './NewInventoryWidget';
function getUnreadCount(notifications = []) {
  return notifications.filter(n => n.isRead === false).length;
}

const Header = ({ colors, logo, userInformation, getProfileDetails, getAppNotifications, loading, notifications, toggleIsRead }) => {
  const navigate = useNavigate();
  const [showNotifications, setShowNotifications] = React.useState(false);
  const bellRef = useRef();
  const [profile, setProfile] = React.useState('');
  const role = JSON.parse(localStorage.getItem('userInfo'))?.job_title;
  const type = JSON.parse(localStorage.getItem('userInfo'))?.organization.type;
  const user_id = JSON.parse(localStorage.getItem('userInfo'))?.id;
  let isCompletedDSO;
  let isCompletedADV;
  if (type === 'DSO')
    isCompletedDSO = JSON.parse(localStorage.getItem('userInfo'))?.isProfileCompleted;
  if (type === 'ADV')
    isCompletedADV = JSON.parse(localStorage.getItem('userInfo'))?.isProfileCompleted;

  const updateNotifications = useCallback(async (user_id) => {
    const data = {
      ids: notifications.filter(n => n.isRead === false).map(n => n.id),
      user_id: user_id
    }
    if (data.ids.length > 0) {
      await toggleIsRead(data);
    }
  }, [toggleIsRead, notifications]);

  const getAllNotifications = useCallback(async (user_id) => {
    const onBehalf = JSON.parse(localStorage.getItem('onBehalfName'));
    const org_id = JSON.parse(localStorage.getItem('userInfo'))?.org_id || null;
    await getAppNotifications({ user_id, onBehalf, org_id });
  }, [getAppNotifications]);

  const handleBellIconClick = async () => {
    if (!showNotifications) {
      await getAllNotifications(user_id);
      await updateNotifications(user_id);
    }
    setShowNotifications(prev => !prev);
  };

  const getDetails = useCallback(async () => {
    const userInfo = JSON.parse(localStorage.getItem('userInfo'));
    await getAllNotifications(userInfo?.id);

    const data = { id: userInfo?.id };
    if (userInfo) {
      await getProfileDetails(data);
    }
  }, [getProfileDetails, getAllNotifications]);

  useEffect(() => {
    getDetails();
  }, [getDetails]);

  useEffect(() => {
    setProfile(userInformation.avatar);
  }, [userInformation]);

  const backToAdimn = () => {
    const data = localStorage.getItem('adminLogged');
    localStorage.setItem('userInfo', data);
    localStorage.removeItem('adminLogged');
    localStorage.removeItem('onBehalfName');
    localStorage.removeItem('savvyTheme');
    navigate('');
    window.location.reload();
  };
  let onBehalfName;
  try {
    onBehalfName = JSON.parse(localStorage.getItem('onBehalfName'));
  } catch {
    onBehalfName = '';
  }

  const isAdmin = !localStorage.getItem('adminLogged') ? (
    ''
  ) : (
    <div className="flex items-center justify-between gap-x-12">
      <div
        className="text-lg font-bold"
        style={{
          color: colors?.mainColor,
        }}
      >
        {onBehalfName || ''}
      </div>
      <button
        onClick={backToAdimn}
        style={{
          background: '#5A3B8C',
        }}
        className="text-white px-4 py-2 rounded-lg"
      >
        Back to admin
      </button>
    </div>
  );
  const LogoImage = logo ? logo : SavvyDisplaysLogo;
  const avatar = JSON.parse(localStorage.getItem('userInfo'))?.avatar

  return (
    <div>
      <header
        style={{
          background: 'rgb(246, 246, 246)',
        }}
        className={`h-[9.3vh]  flex justify-between items-center  w-full  shadow-nav rounded-2xl px-[2.6%]`}
      >
        {isAdmin ? (<div className="flex w-1/2 items-center ">
          <div className="flex w-[12.5vw] items-center">
            <img src={LogoImage} className="h-16  rounded-sm mr-8"></img>
          </div>
          <div
            className="flex items-center flex-1 "
            style={{ color: colors.thirdFontcolor }}
          ></div>

          <div className="flex py-3  w-96 items-center gap-x-4">{isAdmin}</div>
        </div>) : (
          <div className="flex w-1/6 items-center ">
            <div className="flex w-[12.5vw] items-center">
              <img src={LogoImage} className="h-16  rounded-sm mr-8"></img>
            </div>
            <div
              className="flex items-center flex-1 "
              style={{ color: colors.thirdFontcolor }}
            ></div>

            {isAdmin && <div className="flex py-3  w-96 items-center gap-x-4">{isAdmin}</div>}
          </div>)}
        {role !== 'admin' && <div style={{ width: '95%', border: '0px solid black', paddingLeft: '5px' }}>
          {type === 'DSO'
            && isCompletedDSO === false
            && <OnboardingProgressBarDSO />}
          {type === 'ADV'
            && isCompletedADV === false
            && <OnboardingProgressBarADV />}
        </div>}
        <div className="flex items-center justify-end min-w-[12%] ">
          <div className="flex items-center gap-x-3 flex-r">
            {type === 'ADV' && (
              <NewInventoryWidget />
            )}
            <div className="relative">
              <NotificationsIcon
                ref={bellRef}
                onClick={handleBellIconClick}
                style={{ fontSize: '25px', color: 'gray', cursor: 'pointer' }}
              />
              {notifications && !showNotifications && getUnreadCount(notifications) > 0 && (
                <span
                  className="absolute -bottom-2 -left-2 bg-red-600 text-white text-xs font-bold rounded-full flex items-center justify-center"
                  style={{
                    minWidth: 10,
                    minheight: 10,
                    padding: '0 6px',
                    boxShadow: '0 0 0 2px #f6f6f6',
                  }}
                >
                  {getUnreadCount(notifications) > 99 ? '99+' : getUnreadCount(notifications)}
                </span>
              )}
              {showNotifications && (
                <AppNotifications
                  bellRef={bellRef}
                  open={showNotifications}
                  setOpen={setShowNotifications}
                  notifications={notifications}
                  loading={loading}
                />
              )}
            </div>
            <div className="w-12 aspect-square border border-gray-500 rounded-full flex justify-center items-center overflow-hidden">
              {avatar ? (
                <img src={avatar} className="w-full h-full" />
              ) : (
                <Person2Icon style={{ fontSize: '35px' }} />
              )}
            </div>
            <div style={{ color: colors.thirdFontcolor }}>
              {JSON.parse(localStorage.getItem('userInfo'))?.name || ''}
            </div>
          </div>
        </div>
      </header >
    </div >
  );
};
const mapState = (state) => ({
  logoo: state.theme.logoo,
  userInformation: state.profileUpdate.userInformation,
  profileLoading: state.profileUpdate.profileLoading,
  profileCompletedDSO: state.ProgressStepDSO.completed,
  profileCompletedADV: state.ProgressStepAdv.completed,
  notifications: state.AppNotifications.notifications,
  loading: state.AppNotifications.loading,
});
const mapDispatch = (dispatch) => ({
  Upload: (data) => dispatch.theme.Upload(data),
  getProfileDetails: (data) =>
    dispatch.profileUpdate.requestForProfileData(data),
  getAppNotifications: (data) => dispatch.AppNotifications.getAppNotifications(data),
  toggleIsRead: (data) => dispatch.AppNotifications.toggleIsRead(data),
});
export default connect(mapState, mapDispatch)(Header);
